import { Box } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";

export interface Props {
  img?: string;
  mobileImg?: string;
  fullImageHeight?: boolean;
  mobileImgSx?: React.CSSProperties;
  // Fills the panel at a fixed height instead of sizing to the image itself.
  height?: string;
}

export const StepImagePanel = ({
  img,
  mobileImg,
  fullImageHeight = false,
  mobileImgSx,
  height,
}: Props) => {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        // A fixed height sizes the panel to the image rather than the row.
        flex: height && !isMobile ? "0 0 auto" : 1,
        maxWidth: height ? "none" : isMobile ? "auto" : "max-content",
        width: isMobile ? "100%" : "auto",
      }}
    >
      {!isMobile && (
        <img
          src={img}
          style={
            height
              ? {
                  height,
                  width: "auto",
                  maxWidth: "100%",
                  borderRadius: "16px",
                  display: "block",
                }
              : {
                  maxHeight: "585px",
                  borderRadius: "16px",
                  width: "100%",
                  maxWidth: "max-content",
                }
          }
        />
      )}
      {isMobile && (
        <img
          src={mobileImg}
          style={{
            width: "100%",
            borderRadius: "16px",
            maxHeight: fullImageHeight ? "none" : "30vh",
            objectFit: "cover",
            marginBottom: "16px",
            ...mobileImgSx,
          }}
        />
      )}
    </Box>
  );
};
